"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const atoms_1 = require("../../atoms");
const AvatarButton_1 = __importDefault(require("../buttons/AvatarButton"));
const NavBarHorizontal = ({ isAuthenticated, logo, logoutTitle, onLogout, avatar, userTitle, children, }) => {
    return (react_1.default.createElement("nav", { className: "dark:bg-black-700 bg-white" },
        react_1.default.createElement("div", { className: "mx-auto px-2 sm:px-6 lg:px-8" },
            react_1.default.createElement("div", { className: "relative flex justify-between h-16" },
                react_1.default.createElement("div", { className: "flex flex-1 items-stretch justify-start" },
                    react_1.default.createElement("div", { className: "flex flex-shrink-0 items-center" }, logo !== null && logo !== void 0 ? logo : react_1.default.createElement(atoms_1.UniNowLogo, { className: "text-orange-500 h-10 fill-current" }))),
                react_1.default.createElement("div", { className: "absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0" },
                    children,
                    isAuthenticated ? (react_1.default.createElement(AvatarButton_1.default, { type: atoms_1.ButtonType.button, avatar: avatar, title: userTitle, action: logoutTitle, onClick: () => onLogout() })) : null)))));
};
exports.default = NavBarHorizontal;
